module.exports = __webpack_public_path__ + "img/logo-lacomunachilibulo.20e548b7.png";